// extracted by mini-css-extract-plugin
export default {"root":"style_root__YaNbF","card":"style_card__YqIa-","title":"style_title__9hY+x","center":"style_center__56erd"};